export function loadRemembered(key) {
  try {
    return JSON.parse(localStorage.getItem(key) || 'null');
  } catch {
    return null;
  }
}

export function saveRemembered(key, email, password, remember) {
  if (remember) localStorage.setItem(key, JSON.stringify({ email, password }));
  else localStorage.removeItem(key);
}
